import { get, post, put, patch } from "../../../services/api/Config"

const _api_route = `news-and-update`

// ========== Detail Page ========== //
export function SearchContent({ params = {}, lang }) {
  return get({ url: `/v1/admin/${_api_route}`, params, lang })
}
export function GetContentById({ id, lang }) {
  return get({ url: `/v1/admin/${_api_route}/${id}`, lang })
}
export function CreateContent({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/${_api_route}`, params, data, lang })
}
export function UpdateContent({ params = {}, data = {} , id, lang }) {
  return put({ url: `/v1/admin/${_api_route}/${id}`, params, data, lang })
}
export function PatchContent({ params = {}, data = {} , id, lang }) {
  return patch({ url: `/v1/admin/${_api_route}/${id}`, params, data, lang })
}
export function DeleteContent({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/${_api_route}/mutiDelete`, params, data, lang })
}


// ========== Detail Page ========== //
const _api_route_setting = `news-and-update-setting`
export function SettingSearchContent({ params = {}, lang }) {
  return get({ url: `/v1/admin/${_api_route_setting}`, params, lang })
}
export function SettingGetContentById({ id, lang }) {
  return get({ url: `/v1/admin/${_api_route_setting}/${id}`, lang })
}
export function SettingCreateContent({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/${_api_route_setting}`, params, data, lang })
}
export function SettingUpdateContent({ params = {}, data = {} , id, lang }) {
  return put({ url: `/v1/admin/${_api_route_setting}/${id}`, params, data, lang })
}
export function SettingPatchContent({ params = {}, data = {} , id, lang }) {
  return patch({ url: `/v1/admin/${_api_route_setting}/${id}`, params, data, lang })
}
export function SettingDeleteContent({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/${_api_route_setting}/mutiDelete`, params, data, lang })
}

// ========== Leader Thoughts ========== //
const _api_route_leader_thoughts = `leader-thoughts`
export function LeaderThoughtsSearchContent({ params = {}, lang }) {
  return get({ url: `/v1/admin/${_api_route_leader_thoughts}`, params, lang })
}
export function LeaderThoughtsGetContentById({ id, lang }) {
  return get({ url: `/v1/admin/${_api_route_leader_thoughts}/${id}`, lang })
}
export function LeaderThoughtsCreateContent({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/${_api_route_leader_thoughts}`, params, data, lang })
}
export function LeaderThoughtsUpdateContent({ params = {}, data = {} , id, lang }) {
  return put({ url: `/v1/admin/${_api_route_leader_thoughts}/${id}`, params, data, lang })
}
export function LeaderThoughtsPatchContent({ params = {}, data = {} , id, lang }) {
  return patch({ url: `/v1/admin/${_api_route_leader_thoughts}/${id}`, params, data, lang })
}
export function LeaderThoughtsDeleteContent({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/${_api_route_leader_thoughts}/mutiDelete`, params, data, lang })
}

// ========== News VDO ========== //
const _api_route_news_vdo = `news-vdo`
export function VDOSearchContent({ params = {}, lang }) {
  return get({ url: `/v1/admin/${_api_route_news_vdo}`, params, lang })
}
export function VDOGetContentById({ id, lang }) {
  return get({ url: `/v1/admin/${_api_route_news_vdo}/${id}`, lang })
}
export function VDOCreateContent({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/${_api_route_news_vdo}`, params, data, lang })
}
export function VDOUpdateContent({ params = {}, data = {} , id, lang }) {
  return put({ url: `/v1/admin/${_api_route_news_vdo}/${id}`, params, data, lang })
}
export function VDOPatchContent({ params = {}, data = {} , id, lang }) {
  return patch({ url: `/v1/admin/${_api_route_news_vdo}/${id}`, params, data, lang })
}
export function VDODeleteContent({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/${_api_route_news_vdo}/mutiDelete`, params, data, lang })
}
// ========== News Tag ========== //
const _api_route_news_tag = `news-tag`
export function TagSearchContent({ params = {}, lang }) {
  return get({ url: `/v1/admin/${_api_route_news_tag}`, params, lang })
}
export function TagGetContentById({ id, lang }) {
  return get({ url: `/v1/admin/${_api_route_news_tag}/${id}`, lang })
}
export function TagCreateContent({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/${_api_route_news_tag}`, params, data, lang })
}
export function TagUpdateContent({ params = {}, data = {} , id, lang }) {
  return put({ url: `/v1/admin/${_api_route_news_tag}/${id}`, params, data, lang })
}
export function TagPatchContent({ params = {}, data = {} , id, lang }) {
  return patch({ url: `/v1/admin/${_api_route_news_tag}/${id}`, params, data, lang })
}
export function TagDeleteContent({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/${_api_route_news_tag}/mutiDelete`, params, data, lang })
}
